import * as React from "react";

type Props = {
  open: boolean;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  isDanger: boolean;
};

export default function ConfirmationPopup({
  open,
  message,
  confirmText = "OK",
  cancelText = "Cancel",
  isDanger = false,
  onConfirm,
  onCancel,
}: Props) {
  if (!open) return null;

  const styles = useStylesLocal(isDanger);

  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <div
          style={{
            backgroundColor: "#ffffff",
            paddingBottom: "5px ",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              color: "#1f2937",
              margin: 0,
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            Confirmation
          </h2>

          <button
            onClick={onCancel}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: "22px",
              lineHeight: "1",
              color: "#6b7280",
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#111827")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
          >
            ×
          </button>
        </div>

        <p style={styles.message}>{message}</p>

        <div style={styles.buttonRow}>
          <button style={styles.cancelBtn} onClick={onCancel}>
            {cancelText}
          </button>

          <button style={styles.confirmBtn} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
const useStylesLocal = (isDanger: boolean): Record<string, React.CSSProperties> => ({
  overlay: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
  },
  container: {
    background: "white",
    padding: "10px",
    borderRadius: "8px",
    width: "20rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  message: {
    marginBottom: "1rem",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
  },
  cancelBtn: {
    padding: "6px 12px",
    background: "#e5e7eb",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  confirmBtn: {
    padding: "6px 12px",
    background: isDanger ? "#ef4444" : "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
});
